<template>
  <v-container fluid>
    <v-layout row>
      <v-flex xs12 md10 offset-md1 lg8 offset-lg2>
        <v-breadcrumbs divider="/">
          <v-breadcrumbs-item :to="{ name: 'my-services' }" exact>Mine tjenester</v-breadcrumbs-item>
          <v-breadcrumbs-item :to="{ name: 'domain-list' }" exact>Domener</v-breadcrumbs-item>
          <v-breadcrumbs-item disabled>{{ state.domain }}</v-breadcrumbs-item>
        </v-breadcrumbs>

        <v-progress-linear v-if="isSubmitting" :indeterminate="true"></v-progress-linear>

        <notifications group="domain-detail" key="domain-detail" />

        <v-form>
          <v-card class="pa-3" raised>
            <h3>Informasjon</h3>

            <v-text-field
              label="Domene"
              v-model="state.domain"
              readonly
            ></v-text-field>

            <v-layout row wrap>
              <v-flex xs3 md4>Navn</v-flex>
              <v-flex xs2 md1>Type</v-flex>
              <v-flex xs2 md1>Prioritet</v-flex>
              <v-flex xs2 md2>TTL</v-flex>
              <v-flex xs3 md4>Verdi</v-flex>
            </v-layout>

            <v-layout row wrap v-for="(record, i) in state.records" :key="i">
              <v-flex xs3 md4>
                <v-text-field hide-details v-model="record.name" />
              </v-flex>

              <v-flex xs2 md1>
                <v-select
                  hide-details
                  :items="types"
                  v-model="record.type"
                  @input="changedType(record, $event)"
                />
              </v-flex>

              <v-flex xs2 md1>
                <v-text-field
                  hide-details
                  type="number"
                  v-model="record.priority"
                  :readonly="record.type !== 'MX'"
                />
              </v-flex>

              <v-flex xs2 md1>
                <v-text-field
                  hide-details
                  type="number"
                  v-model="record.ttl"
                  @input="changedTTL(record, $event)"
                />
              </v-flex>

              <v-flex xs3 md4>
                <v-text-field
                  append-icon="close"
                  @click:append="state.records.splice(i, 1)"
                  hide-details
                  v-model="record.value"
                />
              </v-flex>
            </v-layout>

            <v-card-actions>
              <v-btn flat @click="addRecord">
                <v-icon small>add</v-icon>
                Legg til record
              </v-btn>

              <v-spacer />
              <v-btn
                color="green darken-2"
                dark
                @click="updateRecords"
              >
                Lagre endringer
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import DomainService from '@/services/DomainService'
import Vue from 'vue'

export default {
  mounted () {
    this.init()
  },
  data () {
    return {
      isSubmitting: false,
      state: {},
      types: ['A', 'CNAME', 'MX', 'NS', 'TXT', 'SRV', 'AAAA']
    }
  },
  methods: {
    async init () {
      const response = await this.runService(this, 'domain-detail', DomainService.get, this.domain)
      if (response) {
        this.state = response.data
      }
    },
    async updateRecords () {
      const response = await this.runService(this, 'domain-detail', DomainService.updateRecords, this.domain, this.state.records)
      if (response) {
        this.state.records = response.data
        this.goBack('Endringene ble lagret!')
      }
    },
    addRecord () {
      this.state.records.push({
        id: 0,
        name: '@',
        type: 'A',
        ttl: 10800,
        value: ''
      })
    },
    goBack (successMessage) {
      if (successMessage) {
        this.addNotification(false, {
          group: 'domain-list',
          type: 'success',
          text: successMessage
        })
      }
      this.$router.push({ name: 'domain-list' })
    },
    changedType (changedRecord, newValue) {
      Vue.set(changedRecord, 'priority', newValue === 'MX' ? '5' : '')
      Vue.set(changedRecord, 'value', '')
    },
    changedTTL (changedRecord, newValue) {
      this.state.records.forEach(record => {
        if (record.name === changedRecord.name) {
          Vue.set(record, 'ttl', newValue)
        }
      })
    }
  },
  computed: {
    domain () {
      return this.$route.params.domain
    }
  }
}
</script>

<style>
#records .v-text-field>.v-input__control>.v-input__slot:before {
  border-style: hidden !important;
}

#records .v-select.v-text-field input {
  opacity: 0;
}
</style>
